<template>
    <div class="payment-page__modal">
        <span class="payment-page__modal__header">Оплата продукта</span>
        <p class="payment-page__modal__title">
            <b>«{{ title }}»</b>
        </p>
        <svg class="payment-page__modal__success-ico" width="57" height="57" viewBox="0 0 57 57" fill="none">
            <path
                d="M25.5873 38.0809C24.8597 38.0809 24.3747 37.8384 23.8896 37.3533L17.5833 30.8043C16.613 29.8341 16.613 28.3787 17.5833 27.4085C18.5535 26.4383 20.0088 26.4383 20.9791 27.4085L25.3448 32.0171L37.4725 17.2212C38.2002 16.251 39.8981 16.0085 40.8683 16.9787C41.8385 17.949 42.081 19.4043 41.1108 20.3746L27.2854 37.3533C27.0428 37.8384 26.315 38.0809 25.5873 38.0809Z"
                fill="#30B39B"
            />
            <path
                d="M28.5001 57.0001C20.981 57.0001 13.7043 54.0894 8.36809 48.7532C-2.78936 37.5957 -2.78936 19.4043 8.36809 8.24688C13.7043 2.9107 20.981 0 28.5001 0C36.0193 0 43.2957 2.9107 48.6319 8.24688C59.7894 19.4043 59.7894 37.5957 48.6319 48.7532C43.2957 53.8468 36.0193 57.0001 28.5001 57.0001ZM28.5001 4.60857C22.1938 4.60857 16.1299 7.03402 11.7639 11.6425C2.54687 20.8596 2.54687 35.8979 11.7639 45.1149C16.1299 49.4808 22.1938 52.149 28.5001 52.149C34.8065 52.149 40.8704 49.7234 45.2364 45.1149C54.4534 35.8979 54.4534 20.8596 45.2364 11.6425C40.8704 7.03402 34.8065 4.60857 28.5001 4.60857Z"
                fill="black"
            />
        </svg>
        <span class="payment-page__modal__header">Оплата поступила</span>
        <a v-if="redirect" :href="redirect" class="btn btn_get-access btn_dark payment-page__modal__redirect-button"
            >Перейти к продукту</a
        >
    </div>
</template>

<script>
export default {
    name: "PaymentSuccess",
    props: ["title", "redirect"]
}
</script>
